import { render } from "./settings_database.vue?vue&type=template&id=2b674869"
import script from "./settings_database.vue?vue&type=script&lang=js"
export * from "./settings_database.vue?vue&type=script&lang=js"
script.render = render

export default script